import React from "react";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error("React Error Boundary caught an error:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    height: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#0a0a0a",
                    color: "#e3e3e3",
                    fontFamily: "sans-serif",
                    textAlign: "center",
                    padding: "20px"
                }}>
                    <h2 style={{ color: "#ff4d4d" }}>¡Ups! Algo salió mal.</h2>
                    <p>La aplicación ha encontrado un error inesperado al renderizar esta página.</p>
                    <button
                        onClick={() => window.location.href = "/"}
                        style={{
                            marginTop: "20px",
                            padding: "10px 20px",
                            backgroundColor: "#ff4d4d",
                            color: "white",
                            border: "none",
                            borderRadius: "5px",
                            cursor: "pointer",
                            fontWeight: "bold"
                        }}
                    >
                        Volver al Inicio
                    </button>
                    {process.env.NODE_ENV === "development" && (
                        <pre style={{
                            marginTop: "30px",
                            padding: "15px",
                            backgroundColor: "#1a1a1a",
                            borderRadius: "5px",
                            maxWidth: "80%",
                            overflowX: "auto",
                            fontSize: "12px",
                            textAlign: "left"
                        }}>
                            {this.state.error?.toString()}
                        </pre>
                    )}
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
